// @flow
import { pathOr } from 'ramda';

type FeeRows = {
  applicationFee: number,
  applicationDescriptions: string,
  adminFee: number,
  adminDescriptions: string,
  depositAlternativeFee: number,
  securityDepositFee: number,
  residentLedgerTotal: number,
  securityLedgerTotal: number,
};

// Reads the same paths as EditHouseholdForm/ApplicationFee.js. The fees query
// resolves to null before it loads, so every path carries a default.
export const getFeeRows = (applicationFees: ?Object): FeeRows => {
  const applicationFee = +pathOr(
    0,
    ['resident', 'application', 'amount'],
    applicationFees,
  );
  const adminFee = +pathOr(0, ['resident', 'admin', 'amount'], applicationFees);
  const depositAlternativeFee = +pathOr(
    0,
    ['resident', 'depositAlternative', 'amount'],
    applicationFees,
  );
  const securityDepositFee = +pathOr(
    0,
    ['security', 'deposit', 'amount'],
    applicationFees,
  );

  return {
    applicationFee,
    applicationDescriptions: pathOr(
      [],
      ['resident', 'application', 'descriptions'],
      applicationFees,
    ).join(', '),
    adminFee,
    adminDescriptions: pathOr(
      [],
      ['resident', 'admin', 'descriptions'],
      applicationFees,
    ).join(', '),
    depositAlternativeFee,
    securityDepositFee,
    residentLedgerTotal: applicationFee + adminFee + depositAlternativeFee,
    securityLedgerTotal: securityDepositFee,
  };
};
